<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-top:100px;">About the Author</h1>
<p>The author is a retired investment banker who was born in France of a White Russian <em>émigré</em> father and a French mother. He grew up and was educated in the United States – at Deerfield Academy and Harvard College. He pursued a distinguished career in the City of London, and then lived in France for many years. He now lives in South Africa. He has published two books: <em>Two Lives, a Social &amp; Financial Memoir</em> in 2017, and <em>Lives of the Luberon</em> in 2019. He is married and has three children.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?430551d3